export const USER_GUIDE_SELECTORS = {
    overview: 'overview',
    posPayments: 'pos-payments',
    posAmexPayments: 'pos-amex-payments',
    onlinePayments: 'online-payments',
    chargebacks: 'chargebacks',
    paymentLinks: 'payment-links',
    createNewPaymentLink: 'new-payment-link-button',
    virtualTerminal: 'virtual-terminal',
    virtualTerminalDetails: 'virtual-terminal-details',
    settlements: 'settlements',
    dcc: 'dcc',
    zashEpos: 'zash-epos',
    referAFriend: 'refer-a-friend',
    digitalReceipts: 'digital-receipts',
    billing: 'billing',
    invoices: 'invoices',
    settlementsDownload: 'settlements-download',
    teamManagementCard: 'team-management-card',
    teamManagementButton: 'team-management-button',
    reports: 'reports',
    paymentMethodsCard: 'payment-methods-card',
    exports: 'exports',
    settings: 'settings',
    companyProfileCard: 'company-profile-card',
    bankAccountsCard: 'bank-accounts-card',
    posOutletsCard: 'pos-outlets-card',
    onlineOutletsCard: 'online-outlets-card'
}
